var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "annonce-pro-full-screen-modal",
      attrs: {
        id: "annonce-pro-modal",
        centered: "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "ok-variant": "primary"
      },
      on: { ok: _vm.handleOk },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("div", { staticClass: "annonce-pro-modal-close-container" }, [
                _c("i", {
                  staticClass:
                    "ph-custom ph-x-bold annonce-pro-modal-close-btn",
                  on: { click: close }
                })
              ])
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleOk($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("annonce.modal.pro.button.ok"))
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "annonce-pro-modal-warning-container" }, [
          _c("i", {
            staticClass: "ph-warning-fill annonce-pro-modal-warning-icon"
          })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "annonce-pro-modal-title" }, [
          _vm._v(_vm._s(_vm.$t("annonce.modal.pro.title")))
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "annonce-pro-modal-text mt-2",
          domProps: { innerHTML: _vm._s(_vm.$t("annonce.modal.pro.text.1")) }
        }),
        _vm._v(" "),
        _c("p", {
          staticClass: "annonce-pro-modal-text",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("annonce.modal.pro.text.2", { proUrlLink: _vm.proUrlLink })
            )
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10b03556", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b03556","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/annonce/AnnonceProModal.vue
// module id = ILQ8
// module chunks = 0